<template>
  <div>
    <vs-card class="cardx">
      <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
        <feather-icon @click="$router.go(-1)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
        <h3>
          {{title}}
        </h3>
      </div>
      <div>
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <ImgInputer
              :img-src="(form.id && !image) ? form.image : (typeof image === 'string' ? image : null)"
              placeholder="Drop image here or click"
              bottom-text="Drop file here or click to change"
              v-model="image"
              accept="image/*"
              theme="light"
              :max-size="9000"
              @onChange="fileChange"/>
          </vs-col>
        </vs-row>

        <div v-if="form.image" style="padding: 0 10px">
          <vs-button @click="showCrop = true" class="mb-3"  color="primary" type="filled">Edit image</vs-button>
        </div>



        <vs-row >
          <vs-col v-if="!partner_namespace" vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <label class="vs-input--label">Partner</label>
            <v-select
              v-model="form.partner_id"
              name="partner"
              v-validate="'required'"
              :class="errors.has('partner') ? 'danger':''"
              :options="partners.partners"
              :reduce="el => el.id" label="name"  />
            <span v-show="errors.has('partner')" class="text-danger">{{ errors.first('partner') }}</span>
          </vs-col>

          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.firstname"
              type="text"
              name="first name"
              v-validate="'required'"
              :danger="errors.has('first name')"
              :danger-text="errors.has('first name')? errors.first('first name'):null"
              val-icon-danger="close"
              label="First name"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.lastname"
              name="last name"
              type="text"
              v-validate="'required'"
              :danger="errors.has('last name')"
              :danger-text="errors.has('last name')? errors.first('last name'):null"
              val-icon-danger="close"
              label="Last name"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.username"
              name="username"
              type="text"
              v-validate="'required'"
              :danger="errors.has('username')"
              :danger-text="errors.has('username')? errors.first('username'):null"
              val-icon-danger="close"
              label="Username"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.password"
              name="password"
              type="password"
              v-validate="'required'"
              :danger="errors.has('password')"
              :danger-text="errors.has('password')? errors.first('password'):null"
              val-icon-danger="close"
              label="Password"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              name="driver_license"
              type="text"
              v-model="form.driver_license"
              v-validate="'required'"
              :danger="errors.has('driver_license')"
              :danger-text="errors.has('driver_license')? errors.first('driver_license'):null"
              val-icon-danger="close"
              label="Driver license"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              name="type_license"
              type="text"
              v-model="form.type_license"
              v-validate="'required'"
              :danger="errors.has('type_license')"
              :danger-text="errors.has('type_license')? errors.first('type_license'):null"
              val-icon-danger="close"
              label="License type"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.phone"
              name="phone"
              type="text"
              v-validate="'required'"
              :danger="errors.has('phone')"
              :danger-text="errors.has('phone')? errors.first('phone'):null"
              val-icon-danger="close"
              label="Phone"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              name="city"
              type="text"
              v-model="form.city"
              v-validate="'required'"
              :danger="errors.has('city')"
              :danger-text="errors.has('city')? errors.first('city'):null"
              val-icon-danger="close"
              label="City"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.reference_id"
              type="text"
              val-icon-danger="close"
              label="External ID"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>

          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
            <vs-checkbox v-model="form.is_active">Enabled</vs-checkbox>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-button color="primary" @click="submit" type="filled">Save</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <vs-card v-if="$route.params.id && false " class="cardx">
      <timeline :data="data_timeline" />
    </vs-card>

    <vs-popup @close="showCrop = false" class="crop-modal"  title="Crop image" :active.sync="showCrop" button-close-hidden>
      <vs-row >
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
          <vue-cropper
            ref="cropper"
            :aspect-ratio="1"
            :src="form.image"
            alt="Source Image"
            :imgStyle="{width: '500px!important', height: '300px!important'}"
            :containerStyle="{width: '500px!important', height: '300px!important'}"
            :min-container-height="300"
            :min-container-width="300"
          />
        </vs-col>
        <vs-col>
          <vs-button @click="showCrop = false" class="mr-3"  color="primary" type="filled">Cancelar</vs-button>
          <vs-button @click="cropImage"  color="success" type="filled">Crop</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>

</template>
<style itemscope>
  .img-inputer {
    width: 150px;
    height: 150px;
  }
  .preview {
    width: 300px;
    height: 300px;
  }
  .cropper-container{
    width: 500px!important;
    height: 300px!important;
  }


</style>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import ImgInputer from 'vue-img-inputer';
  import moment from 'moment'
  import Timeline from "../../components/charts/Timeline";

  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';

  export default {
    name :'EditDriver',
    components: {
      ImgInputer,
      'timeline': Timeline,
      VueCropper
    },
    data(){
      return {
        fetching : true,
        title : null,
        form:{
          partner_id : null,
          firstname: null,
          lastname: null,
          username: null,
          password: null,
          driver_license: null,
          type_license: null,
          phone: null,
          city: null,
          is_active:true
        },
        onSubmit : false,
        image : null,
        imgBase64 : null,

        data_timeline : [],
        showCrop: false
      }
    },
    computed : {
      ...mapState(['partner_namespace']),
      ...mapGetters('users',['userCan']),
      ...mapState('partners',['partners']),
    },
    watch :{
      '$route.params.id': function (id) {
        this.initData();
      }
    },
    created() {
      this.initData();
    },

    methods: {
      ...mapActions('drivers',['getDriver','storeDriver','updateDriver']),
      initData(){
        if(this.$route.params.id){
          this.title = 'Edit driver';
          this.getDriver({id: this.$route.params.id})
            .then(data=>{
              this.form = data;
              this.form.partner_id = data.partner ? data.partner.id : null;
              this.fetching = false;
              if(this.form.image){
                setTimeout(()=>{
                  this.$refs.cropper.replace(this.form.image);
                },300);
              }

            })
            .catch(error=>{
              console.log(error)
              if(error){
                if(error.status === 404){
                  //this.$router.push({name: 'page-error-404'});
                }
              }
            })
          this.getTimeline();
        }else{
          this.title = 'New driver';
          this.fetching = false;
          this.form = {
            partner_id : this.partner_namespace,
            firstname: null,
            lastname: null,
            username: null,
            password: null,
            driver_license: null,
            type_license: null,
            phone: null,
            city: null,
            is_active:true
          };
        }
      },
      async submit(){
        let result = await this.$validator.validateAll();
        if (!result || this.onSubmit) {
          return;
        }
        this.$vs.loading({
          type:'point',
        });
        this.onSubmit = true;

        if(this.$route.params.id){
          if(!this.userCan('drivers.update')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }

          let form = _.cloneDeep(this.form);
          delete form.partner;
          if(!this.imageBase64){
            delete form.image
          }else{
            form.image = this.imageBase64;
          }

          this.updateDriver(form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Driver successfully updated',this.redirectToDrivers);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 409 || error.status === 400){
                  this.setErrors(error.data.errors);
                }else{
                    this.$vs.notify({
                      color: 'danger',
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                }
              }
            })
        }else{
          if(!this.userCan('drivers.create')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }

          let form = _.cloneDeep(this.form);
          if(this.imageBase64){
            form.image = this.imageBase64;
          }
          this.storeDriver(form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Driver successfully created',this.redirectToDrivers);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 409 || error.status === 400){
                  this.setErrors(error.data.errors);
                }else{
                    this.$vs.notify({
                      color: 'danger',
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                }
              }
            })
        }
      },
      msgDialog(color, title, text, action){
        this.$vs.dialog({
          color: color,
          title: title,
          text: text,
          accept:action
        })
      },
      redirectToDrivers(){
        if(this.partner_namespace){
          this.$router.push({name: 'partner.drivers.list'});
        }else{
          this.$router.push({name: 'drivers List'});
        }
      },
      fileChange(file,filename){
        let reader = new FileReader()
        reader.readAsDataURL(this.image)
        reader.onload = (event)=> {
          this.imageBase64 = reader.result.split(',').pop();
          this.showCrop = true;
          setTimeout(()=>{
            this.$refs.cropper.replace(reader.result);
          },300);
        };
      },
      cropImage(){
        this.image = this.$refs.cropper.getCroppedCanvas().toDataURL();
        const cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.imageBase64 = cropImg.split(',').pop();
        this.showCrop = false;
      },
      setCenter(){
        this.$refs.cropper.zoomTo(1);
      },
      setErrors(errors){
        for(let key in errors){
          if(Array.isArray(errors[key])){
            this.errors.add({
              field: key,
              msg: errors[key][0]
            });
          }
        }
      },
      getTimeline(){
        let data = [];

        let start = moment().startOf('day').add(5, 'hour');
        for(let i = 0; i<4; i++ ){
          start = start.add(1, 'hour');
          data.push( {
            "start": start.format('YYYY-MM-DD HH:mm:ss'),
            "end": start.add(1,'hour').format('YYYY-MM-DD HH:mm:ss'),
            "route": "Nombre de la ruta"
          });

          start = start.add(2, 'hour');
        }
        this.data_timeline = data;
      },

    },

  }
</script>
